import { ApolloError, useQuery } from '@apollo/client'
import { FindCountriesHrIsResponsibleOfQuery, FindCountriesHrIsResponsibleOfQueryVariables } from '../../../types'
import { GET_COUNTRIES_HR_IS_RESPONSIBLE_FOR } from '../Queries'

export default (): {
  data: FindCountriesHrIsResponsibleOfQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<FindCountriesHrIsResponsibleOfQuery, FindCountriesHrIsResponsibleOfQueryVariables>(
    GET_COUNTRIES_HR_IS_RESPONSIBLE_FOR,
  )

  return { data, error, loading }
}
